import { useCallback, useEffect, useState } from 'react'
import { funnelApi } from '../api/funnel-api'
import type { PricingViewEntry } from '../types'

export function usePricingView() {
  const [entries, setEntries] = useState<PricingViewEntry[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchPricingView = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await funnelApi.getPricingView()
      setEntries(response.data)
    } catch {
      setError('Failed to load pricing view')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchPricingView()
  }, [fetchPricingView])

  return { entries, loading, error, refetch: fetchPricingView }
}
